import FormField from "components/FormField";
import DropdownMenu from "./DropdownMenu";
import { formHeader } from "../utils/getShiftRow";
import { TIMEZONE_LIST } from "utils/constants";
import userService from "services/user.service";
import { useEffect } from "react";
import { useState } from "react";
import classNames from "classnames";
import styles from "./Header.module.scss";

const Header = ({
  setShowModal,
  setModalState,
  editingId,
  schedulesData = [],
  currentScreen,
  setSelectedBreak,
  setSelectedTimezone,
  setSelectedForecasting,
  selectedBreak,
  selectedTimezone,
  selectedForecasting,
  handleChange,
  scheduleName,
  showModal,
  setLoading,
  formErrors,
}) => {
  const [workTimeForecastingParams, setWorkTimeForecastingParams] = useState(
    [],
  );
  const [breaksList, setBreaksList] = useState([]);

    function formatedTimezone(data) {
    const list = TIMEZONE_LIST.map((item) => {
      return {
        title: item.title.split(" ")[0],
        value: item.value,
      };
    });

    return list;
  }

  useEffect(() => {
    setLoading(true);
    const asyncWraperWorkTimeForecasting = async () => {
      setLoading(true);
      try {
        const workTimeForecasting = await userService.getWorkTimeForecasting();
        const listWorkTimeForecasting = workTimeForecasting.map(
          (forecasting) => {
            return forecasting;
          },
        );
        setWorkTimeForecastingParams(listWorkTimeForecasting);
      } catch (error) {
        console.error("error:", error);
      } finally {
        setLoading(false);
      }
    };

    const asyncWraperBreaks = async () => {
      setLoading(true);
      try {
        const breaks = await userService.getBreaks();
        const listOfBreaks = breaks.map((item) => {
          return {
            min: `${item.min_duration}`,
            max: `${item.max_duration}`,
          };
        });
        setBreaksList(listOfBreaks);
      } catch (error) {
        console.error("error:", error);
      } finally {
        setLoading(false);
      }
    };

    asyncWraperWorkTimeForecasting();
    asyncWraperBreaks();
  }, [setLoading, showModal]);

  return (
    <>
      <FormField
        {...formHeader[0]}
        style={formHeader[0].className}
        className={formHeader[0].className}
        onChange={handleChange}
        value={scheduleName}
        required={true}
        error={formErrors.name || false}
      />
      <p
        className={classNames(
          styles.error_message,
          formErrors.length !== 0 && styles.active,
        )}
      >
        {formErrors.form}
      </p>
      <DropdownMenu
        {...formHeader[1]}
        data={breaksList}
        setShowModal={setShowModal}
        setModalState={setModalState}
        schedulesData={schedulesData}
        editingId={editingId}
        currentScreen={currentScreen}
        setSelectedBreak={setSelectedBreak}
        selectedBreak={selectedBreak}
        formErrors={formErrors.breaks || false}
      />

      <DropdownMenu
        {...formHeader[2]}
        currentScreen={currentScreen}
        data={formatedTimezone(TIMEZONE_LIST)}
        setSelectedTimezone={setSelectedTimezone}
        selectedTimezone={selectedTimezone}
        formErrors={formErrors.timezone || false}
      />
      <DropdownMenu
        key={selectedForecasting}
        {...formHeader[3]}
        data={workTimeForecastingParams}
        setShowModal={setShowModal}
        setModalState={setModalState}
        schedulesData={schedulesData}
        editingId={editingId}
        currentScreen={currentScreen}
        setSelectedForecasting={setSelectedForecasting}
        selectedForecasting={selectedForecasting}
        formErrors={formErrors.forecasting || false}
      />
    </>
  );
};
export default Header;
